import React from 'react';

const RewardCoinIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="12" cy="12" r="10" fill="#E6B800" stroke="#D4A500" strokeWidth="1" />
            <path
                d="M12 6L13.2 9.6L17 10L14 12.8L14.8 16.4L12 14.2L9.2 16.4L10 12.8L7 10L10.8 9.6L12 6Z"
                fill="#B8860B"
            />
        </svg>
    );
};

export default RewardCoinIcon;
